import {
    CREATE_TAG_REQUEST,
    createTagSuccess,
    createTagFailure,
    showSuccessNotification
} from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic } from "Redux/Config";

export const createTagEpic: TEpic = (action$, store$, { TagRepository }) => {
    return action$.pipe(
        ofType(CREATE_TAG_REQUEST),
        mergeMap(action => from(TagRepository.create( action.payload ))
            .pipe(
                mergeMap((tag) => {
                    return from([
                        showSuccessNotification(`Tag wurde erfolgreich erstellt`),
                        createTagSuccess( tag ),
                    ]);
                }),
                catchError( error => {
                    return from([
                        createTagFailure(error),
                    ])
                })
            )
        ),
    );
}
